import Box from '@mui/material/Box';
import { styled } from '@mui/styles';

import DesktopCover from '../../assets/images/ramazan-desktop-banner-2026.jpg';
import MobileCover from '../../assets/images/ramazan-mobile-banner-2026.jpg';

export const StyledHome = styled(Box)(({ theme }) => ({
	'& .Footer': {
		marginTop: 0,
	},

	'& .HeaderMainStack': {
		width: '100%',
		position: 'absolute',
		color: 'white',
		boxShadow: 'none',
		zIndex: 1,

		'& .MuiSvgIcon-root, svg': {
			color: '#fff',
		},

		'& .MuiDivider-root': {
			borderColor: '#fff',
		},
	},

	'& .HomeCoverBox': {
		backgroundImage: `url(${DesktopCover})`,
		height: '560px',
		display: 'flex',
		color: 'white',
		alignItems: 'center',
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		position: 'relative',
		overflow: 'hidden',
		backgroundRepeat: 'no-repeat',

		[theme.breakpoints.down('sm')]: {
			backgroundImage: `url(${MobileCover})`,
			height: '100vh',
			justifyContent: 'center',
			textAlign: 'center',
			alignItems: 'unset',
			paddingTop: '150px',
		},
		'& .HomeCoverStack': {
			maxWidth: '660px',
		},
		'& .StartButton': {
			color: 'white',
			borderColor: 'white',
			marginTop: '8px',
		},
		'&::before': {
			content: '""',
			width: '100%',
			height: '100%',
			position: 'absolute',
			top: '0',
			left: '0',
			backgroundColor: 'rgba(0,0,0,0)',
		},
		'& .HomeCoverContainer': {
			position: 'relative',
			zIndex: 1,
		},
	},

	'& .StepBG-1': {
		backgroundColor: theme.palette.primary.main,
	},
	'& .StepBG-2': {
		backgroundColor: '#F39200',
		paddingBottom: '40px',
	},
	'& .StepBG-3': {
		backgroundColor: theme.palette.primary.light,
		paddingBottom: '40px',
	},
	'& .StepBox': {
		color: '#fff',
		textAlign: 'center',

		'& .StepContainer': {
			paddingTop: '40px',

			'& .MuiTypography-h3, .MuiTypography-h4': {
				fontWeight: 'bold',
			},
			'& .Step-1': {
				flexDirection: 'row',
			},
			'& .Step-2': {
				flexDirection: 'row-reverse',
			},
			'& .Step-3': {
				flexDirection: 'row',
			},

			'& .StepStack': {
				marginTop: '40px',
				alignItems: 'center',
				justifyContent: 'space-between',

				'& .StepContentBox': {
					textAlign: 'left',
					flexBasis: '40%',

					'& .StepTitle': {
						fontWeight: 'bolder',
					},

					'& .CreateLink': {
						color: '#fff',
						textDecorationColor: '#fff',
						fontSize: '18px',
					},
				},

				'& .StepSvgBox': {
					flexBasis: '50%',
					margin: 'auto',
					'& img': {
						width: '385px',
						height: '100%',
					},
				},
				[theme.breakpoints.down('sm')]: {
					flexDirection: 'column',
					gap: '20px',
				},
			},
			'& .StepContentSubtitle': {
				fontWeight: 600,
				fontSize: '20px',
				[theme.breakpoints.down('sm')]: {
					fontSize: 'unset',
				},
			},

			'& .StepContent': {
				fontSize: '18px',
				[theme.breakpoints.down('sm')]: {
					fontSize: 'unset',
				},
			},
		},
	},

	'& .GetInspiredSection': {
		marginTop: '40px',
		marginBottom: '40px',

		'& .StartYourFundraiserButton': {
			'&:hover': {
				color: 'white',
			},
		},
	},

	'& .TopPagesSection': {
		backgroundColor: '#FAFAFA',
		padding: '40px 0',

		'& .TopPagesStack': {
			flexDirection: 'row',
			justifyContent: 'space-around',

			[theme.breakpoints.down('sm')]: {
				flexDirection: 'column',
				gap: '40px',
			},

			'& .TopPagesBox': {
				flexBasis: 'calc(33.33333% - 15px)',
				maxWidth: '30%',

				[theme.breakpoints.down('sm')]: {
					maxWidth: 'unset',
				},

				'& .PagesHeader': {
					fontSize: '18px',
				},

				'& .FundraiserCard': {
					flexDirection: 'row',
					gap: '16px',
					marginTop: '15px',

					'& .progress': {
						margin: 0,
					},

					'& .ImageBox': {
						width: '60px',
						height: '60px',
						borderRadius: '5px',
						border: `0.5px solid ${theme.palette.neutral.light}`,

						'& img': {
							objectFit: 'cover',
							height: '100%',
							width: '100%',
							borderRadius: 'inherit',
						},
					},

					'& .DetailsBox': {
						overflow: 'hidden',
						whiteSpace: 'nowrap',
						flexBasis: '80%',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'space-between',

						'& .PageTitle': {
							maxWidth: '100%',
							fontSize: '16px',

							'& .MuiTypography-root': {
								overflow: 'hidden',
								textOverflow: 'ellipsis',
							},
						},
					},
				},
			},
		},
	},
}));
